// extracted by mini-css-extract-plugin
module.exports = {"sponsored__container":"SponsoredBanner_sponsored__container__WWJHC"};